// Small info affordance: an ⓘ next to a field label whose hover tooltip carries
// the help text that used to live in an inline explainer paragraph. Self-contained
// TooltipProvider matches the avatars-cell.tsx pattern.
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Info } from "lucide-react";

export function FieldInfo({ text }: { text: string }) {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="More info"
            style={{
              display: "inline-flex",
              alignItems: "center",
              marginLeft: 6,
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: "help",
              color: "var(--iris-fg-4)",
            }}
          >
            <Info size={12} />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-[280px]">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
